// this causes a warning log at runtime
// @ts-ignore
globalThis.__VUE_PROD_DEVTOOLS__ = false;
